import { render } from "./GeojsonTable.vue?vue&type=template&id=5bd8ecc8"
import script from "./GeojsonTable.vue?vue&type=script&lang=js"
export * from "./GeojsonTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__